import React from "react";

/**
 * SuiteLogo — Marchio del Modulo Presenze (Gruppo Impresa Suite).
 *
 * Riprende esattamente il disegno usato nella favicon (`favicon.ico`) e nel
 * lockup della pagina di login: tre figure di persone bianche disposte su
 * fondo verde brand `#4CAF50` con angoli arrotondati. Simbolo di "team" —
 * coerente con l'identità del Gestionale Presenze.
 *
 * `size` controlla il lato del quadrato in pixel; la geometria interna
 * scala automaticamente con `s / 32` come nel generatore Python della
 * favicon (frontend/public/favicon.ico) → risultato pixel-perfect.
 */
export function SuiteLogo({ size = 40, className = "" }) {
  const s = size;
  const r = Math.max(2, Math.round(s * 0.18));
  return (
    <div
      className={`relative flex-shrink-0 shadow-sm ${className}`}
      style={{ width: s, height: s }}
      aria-label="Gestionale Presenze — Gruppo Impresa Suite"
    >
      <svg
        width={s}
        height={s}
        viewBox="0 0 32 32"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
      >
        {/* Fondo verde brand con angoli arrotondati */}
        <rect x="0" y="0" width="32" height="32" rx={r * (32 / s)} fill="#4CAF50" />
        {/* Persona centrale (grande) — testa */}
        <ellipse cx="16" cy="10" rx="3" ry="3" fill="#FFFFFF" />
        {/* Persona centrale — busto (arco pieno) */}
        <path d="M10 20 A 6 6 0 0 1 22 20 L 22 20 L 10 20 Z" fill="#FFFFFF" />
        {/* Persona sinistra (piccola) — testa */}
        <ellipse cx="7.5" cy="13.5" rx="2.5" ry="2.5" fill="#FFFFFF" />
        {/* Persona sinistra — busto */}
        <path d="M2 22 A 5.5 5.5 0 0 1 13 22 L 13 22 L 2 22 Z" fill="#FFFFFF" />
        {/* Persona destra (piccola) — testa */}
        <ellipse cx="24.5" cy="13.5" rx="2.5" ry="2.5" fill="#FFFFFF" />
        {/* Persona destra — busto */}
        <path d="M19 22 A 5.5 5.5 0 0 1 30 22 L 30 22 L 19 22 Z" fill="#FFFFFF" />
      </svg>
    </div>
  );
}

export default SuiteLogo;
